import { getdata, loaddata ,error} from "./actiontype"
const initialState={
    card:[],
    isloading:false,
    isError:false
}
const reducer=(state=initialState,action)=>{
    const {payload,type} = action
    switch(type){
       case loaddata:
        return{...state,isloading:true}
       case getdata:
        return {...state,isloading:false,card:payload}
      case error:
        return {...state,error:true}    
        default:
            return state
    }
}
export {reducer}